import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatutRapportIncident } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-status',
  templateUrl: './rapport-incident-status.component.html',
  styleUrls: ['./rapport-incident-status.component.css']
})
export class RapportIncidentStatusComponent implements OnInit {

  @Input() public status: number;
  @Input() public canAccessModifyIncidentReport: number;

  StatutsRapportIncident = StatutRapportIncident;
  
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetStatutRapport(s: StatutRapportIncident) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Rapports.RapportsIncidents.Statuts.' + StatutRapportIncident[s]);
    }
  }

}
